<template>
    <div class='qualityDetailBox'>
        <QualityDetail :form="form" :userType="userType"></QualityDetail>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import QualityDetail from '@/components/consultant/QualityDetail.vue'
export default {
    name: "qualityDetailBox",
    components: {
        Button,
        QualityDetail
    },
    data() {
        return {
            swiperIndex: 0,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            userType:2,
            id: this.$route.query.id,
            form: {}
        }
    },
    created() {
        if(this.id) {
            this.detailComplexQualityByStudent()
        }else {
            this.form  = JSON.parse(window.sessionStorage.getItem("formQuality"));
        }
    },
    methods: {
      // 获取综合素质详情
        detailComplexQualityByStudent(){
        let id = this.$route.query.id;
        this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.quality.detailComplexQualityByParent, {
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.form = res.data.data;
          }
        })
      },
    },
}
</script>
<style scoped lang="less">
.qualityDetailBox {

}
</style>